import React, { useEffect, useState } from 'react';
import Select from 'react-select'; // ✅ Using React Select
// 👇 NAYA CODE: customFetch import kiya
import { customFetch } from '../apiClient'; 

const DiscountAuthorityDropdown = ({ 
  value, 
  onChange, 
  label, 
  styles,
  required = false, 
  disabled = false,
  placeholder = "Select Authority...",
  showLabel = true 
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadAuthorities = async () => {
      try {
        setLoading(true);
        
        // 👇 NAYA CODE: customFetch use kiya (Token aur headers ab apne aap handle honge)
        const res = await customFetch(`/DiscountAuthDt`);
        
        if (!res.ok) throw new Error("Failed to load authorities");
        const data = await res.json();
        
        // ✅ Data ko React Select format me convert karein
        const formattedOptions = (data || []).map(auth => ({
            value: auth.authority,
            label: `${auth.type}: ${auth.authority}`
        }));
        
        setOptions(formattedOptions);
      } catch (err) {
        setError(err.message);
        console.error("❌ Discount Authority Load Error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadAuthorities();
  }, []);

  // ✅ INTERNAL DYNAMIC STYLES (Same as other files)
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '26px',
      fontSize: '13px',
      borderRadius: '6px',
      borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#cbd5e0',
      boxShadow: state.isFocused ? '0 0 0 3px color-mix(in srgb, var(--theme-color, #0088cc), transparent 85%)' : 'none',
      '&:hover': { borderColor: 'var(--theme-color, #0088cc)' },
      borderWidth: '1.5px'
    }),
    menu: (base) => ({ ...base, zIndex: 9999, borderRadius: '6px' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
      ...base,
      fontSize: '13px',
      padding: '8px 12px',
      backgroundColor: state.isSelected 
        ? 'var(--theme-color, #0088cc)' 
        : state.isFocused 
          ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' 
          : 'white',
      color: state.isSelected ? 'white' : '#333',
      cursor: 'pointer',
      '&:active': { backgroundColor: 'var(--theme-color, #0088cc)', color: 'white' }
    }),
    placeholder: (base) => ({ ...base, color: '#a0aec0', fontSize: '13px' })
  };

  // ✅ Value match karne ka logic (String value ko Object banana)
  const selectedOption = options.find(opt => opt.value === value) || null;

  return (
    <>
      {showLabel && label && (
        <label className="form-label small mb-1" style={{ fontSize: '12px', fontWeight: '600', color: '#2c3e50' }}>
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      
      {error ? (
        <div className="text-danger small">{error}</div>
      ) : (
        <Select
          value={selectedOption}
          onChange={(opt) => onChange(opt)} // Parent ko pura option object bhejein
          options={options}
          isDisabled={disabled || loading}
          isLoading={loading}
          placeholder={loading ? "Loading..." : placeholder}
          isClearable
          styles={styles || selectStyles} // ✅ Dynamic Styles Applied
          menuPortalTarget={document.body} 
        />
      )}
    </>
  );
};

export default DiscountAuthorityDropdown;